// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const CogSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39 39"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M14.9 5.9c-1.1 3.2-1.6 3.4-6 3.2-3.6-.3-6 4.1-3.6 6.7 2.1 2.3 2.1 4.1 0 6.4-2.4 2.6 0 7 3.6 6.7 4.4-.2 4.9 0 6 3.2.9 2.6 1.4 3 4.3 2.7 2.5-.2 3.4-.9 3.8-2.8.5-2 1.2-2.5 4-2.6 2.4 0 3.9-.7 5.4-2.7l2-2.7-2.4-2.5-2.3-2.5 2.3-2.5 2.4-2.5-2-2.7c-1.5-2-3-2.7-5.4-2.7-2.8-.1-3.5-.6-4-2.6-.4-1.9-1.3-2.6-3.8-2.8-2.9-.3-3.4.1-4.3 2.7zm6.5 1.6c.6 2.5 4.3 4.2 6.9 3.2.7-.3 1.9.3 2.5 1.3.9 1.4.8 2.1-.3 3-1.9 1.6-1.9 6.4 0 8 1.1.9 1.2 1.6.3 3-.6 1-1.8 1.6-2.5 1.3-2.6-1-6.3.7-6.9 3.2-.9 3.6-5.4 3.6-5.4 0 0-1.8-.7-2.6-2.5-3.1-1.4-.3-3.2-.4-4 0-.9.3-1.9-.3-2.6-1.6-.9-1.7-.8-2.3.5-3 2.1-1.2 2.1-6.4 0-7.6-1.3-.7-1.4-1.3-.5-3 .7-1.3 1.7-1.9 2.6-1.6.8.4 2.6.3 4 0 1.8-.5 2.5-1.3 2.5-3.1 0-3.6 4.5-3.6 5.4 0z" />
      <path d="M15.2 14.6c-3 2-3 6.8 0 8.8 4.4 3.1 8.8.9 8.8-4.4 0-5.3-4.4-7.5-8.8-4.4zM22 17c2.2 4-2.6 8-5.8 4.8-2.5-2.5-.6-6.8 3-6.8.9 0 2.2.9 2.8 2z" />
    </svg>
  )
}
